import { render, staticRenderFns } from "./locationDetails.vue?vue&type=template&id=56ff9900&scoped=true&"
import script from "./locationDetails.vue?vue&type=script&lang=js&"
export * from "./locationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff9900",
  null
  
)

export default component.exports